import _convertToPlainText from "../quill/convertToPlainText.js";
const convertToPlainText = _convertToPlainText;
export default (function getCps(event) {
  let duration = event.end - event.start;
  let totalChars = convertToPlainText(event.text, " ").length;
  return totalChars / duration;
});